import React, { TableHTMLAttributes } from 'react'
import styles from './Table.module.scss'

const Table: React.FC<TableHTMLAttributes<HTMLTableElement>> = ({
  children,
  ...props
}) => {
  return (
    <div className={styles.tableContainer}>
      <table className={styles.table} {...props}>
        {children}
      </table>
    </div>
  )
}

export default Table
